import request from "../../Request";
import {rThen} from "../../requestThen";

export let getRegionByCountry = async (country) => {

    return request.get(`/api/Regions/get_states/${country}`, false).then(r => {
        return rThen(r);
    })
}